export default [
  {
    path: "/shop",
    name: "ShopView",
    component: () => import("../../views/ShopView/ShopView.vue"),
  },
];
